// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1zMTK","item":"PaymentsMobile_item__38alx","label":"PaymentsMobile_label__2LwVh","amount":"PaymentsMobile_amount__2WLdI"};